import { render, staticRenderFns } from "./ehc-header.vue?vue&type=template&id=dcd14de2"
import script from "./ehc-header.vue?vue&type=script&lang=js"
export * from "./ehc-header.vue?vue&type=script&lang=js"
import style0 from "./ehc-header.vue?vue&type=style&index=0&id=dcd14de2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports